import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.div `
  @media ${from(Device.TabletSmall)} {
    &[data-mobile-only='true'] {
      display: contents;
    }
  }
`;
const Track = styled(m.ul) `
  display: flex;

  @media ${from(Device.TabletSmall)} {
    [data-mobile-only='true'] & {
      display: contents;
    }
  }
`;
const SimpleTrackStyles = {
    Container,
    Track,
};
export default SimpleTrackStyles;
